import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Device } from '../device.model';
import { DeviceActions, DeviceActionTypes } from '../actions/device.actions';

export interface State extends EntityState<Device> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<Device> = createEntityAdapter<Device>({
  selectId: device => device.Id
});


export const initialState: State = adapter.getInitialState({
  Loaded: false,
  Loading: false
});

export function reducer(
  state = initialState,
  action: DeviceActions
): State {
  switch (action.type) {
    case DeviceActionTypes.GetDevices: {
      return {...state, Loaded: false, Loading: true};
    }

    case DeviceActionTypes.GetDevicesByAcodeList: {
      return {...state, Loaded: false, Loading: true};
    }

    case DeviceActionTypes.GetDevicesFail: {
      return {...state, Loaded: true, Loading: false};
    }

    case DeviceActionTypes.AddDevice: {
      return adapter.addOne(action.payload.device, state);
    }

    case DeviceActionTypes.UpsertDevice: {
      return adapter.upsertOne(action.payload.device, state);
    }

    case DeviceActionTypes.AddDevices: {
      return adapter.addMany(action.payload.devices, state);
    }

    case DeviceActionTypes.UpsertDevices: {
      return adapter.upsertMany(action.payload.devices, {...state, Loaded: true, Loading: false});
    }

    case DeviceActionTypes.UpdateDevice: {
      return adapter.updateOne(action.payload.device, state);
    }

    case DeviceActionTypes.UpdateDevices: {
      return adapter.updateMany(action.payload.devices, state);
    }

    case DeviceActionTypes.DeleteDevice: {
      return adapter.removeOne(action.payload.id, state);
    }

    case DeviceActionTypes.DeleteDevices: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case DeviceActionTypes.LoadDevices: {
      return adapter.setAll(action.payload.devices, state);
    }

    case DeviceActionTypes.ClearDevices: {
      return adapter.removeAll(state);
    }

    case DeviceActionTypes.NoDevicesChanged: {
      return {...state, Loaded: true, Loading: false};
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
